// Available notification sounds
export const availableSounds = {
  'gentle-chime': 'https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3',
  'soft-bell': 'https://assets.mixkit.co/active_storage/sfx/954/954-preview.mp3',
  'notification': 'https://assets.mixkit.co/active_storage/sfx/1114/1114-preview.mp3',
  'alert': 'https://assets.mixkit.co/active_storage/sfx/2870/2870-preview.mp3',
  'success': 'https://assets.mixkit.co/active_storage/sfx/2872/2872-preview.mp3',
  'ping': 'https://assets.mixkit.co/active_storage/sfx/2873/2873-preview.mp3'
};

export type SoundId = keyof typeof availableSounds;

// Default sound mappings
const defaultSoundMappings: Record<NotificationType, SoundId> = {
  equipment: 'gentle-chime',
  returns: 'soft-bell',
  hallPasses: 'notification',
  birthdays: 'success',
  summons: 'alert'
};

// Get sound mappings from memory (no longer using localStorage)
let soundMappings = { ...defaultSoundMappings };

// Notification sounds for different types
const notificationSounds: Record<SoundId, HTMLAudioElement> = {} as Record<SoundId, HTMLAudioElement>;

// Initialize audio elements
Object.entries(availableSounds).forEach(([id, url]) => {
  notificationSounds[id as SoundId] = new Audio(url);
});

export type NotificationType = 'equipment' | 'returns' | 'hallPasses' | 'birthdays' | 'summons';

export const playNotificationSound = (type: NotificationType) => {
  try {
    const soundId = soundMappings[type];
    const sound = notificationSounds[soundId];
    sound.currentTime = 0; // Reset audio to start
    sound.play().catch(error => {
      console.warn('Audio playback failed:', error);
    });
  } catch (error) {
    console.warn('Audio playback failed:', error);
  }
};

// Preview a specific sound
export const previewSound = (soundId: SoundId) => {
  try {
    const sound = notificationSounds[soundId];
    sound.currentTime = 0;
    sound.play().catch(error => {
      console.warn('Audio playback failed:', error);
    });
  } catch (error) {
    console.warn('Audio playback failed:', error);
  }
};

// Update sound mapping for a notification type (stored in memory only)
export const updateSoundMapping = (type: NotificationType, soundId: SoundId) => {
  soundMappings[type] = soundId;
  // Sound mappings are now stored in memory only
  // Consider saving to user preferences via API if persistence is needed
};

// Get current sound mapping for a notification type
export const getCurrentSound = (type: NotificationType): SoundId => soundMappings[type];